import { minutesToMilliseconds } from 'date-fns'
import { uniqBy } from 'lodash-es'

import { SearchData, SearchRequestWithTrain, SearchResult } from '@/travelsuit'
import {
	GetSearchParamsResponseZ,
	GetSearchResultsResponseZ,
	SearchId,
	SearchJobStatus,
	StartSearchRequestZ,
	StartSearchResponseZ,
} from '@/types/search'

import { getGGClient, RequestOverrides } from './GetGoingClient'

export async function getSearchParams(searchId: SearchId, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `search/${searchId}`, {
			responseSchema: GetSearchParamsResponseZ,
			...overrides,
		})
		.then((r) => r.data as unknown as SearchData)
}

/** Legacy workflow: doesn't throw of failure */
export async function getSearchResultsLegacy(searchId: SearchId, overrides?: RequestOverrides) {
	return getGGClient()
		.pollJobResult(`search/${searchId}/results`, {
			responseSchema: GetSearchResultsResponseZ,
			mapJobResult: ({ data }, poll) =>
				data.status === SearchJobStatus.Success || data.status === SearchJobStatus.Failed
					? (data as unknown as SearchResult)
					: poll,
			pollTime: minutesToMilliseconds(10), // We saw get flight search results time of 5:17 minutes
			...overrides,
		})
		.then((result) => {
			// Remove duplicate flight identifiers which are corner cases that we can't resolve yet
			return result.flight_results?.results.length
				? {
						...result,
						flight_results: {
							...result.flight_results,
							results: uniqBy(result.flight_results.results, (bo) => bo.flight_identifier),
						},
					}
				: result
		})
}

export async function startSearch(params: SearchRequestWithTrain, overrides?: RequestOverrides) {
	return getGGClient()
		.request('POST', 'search', {
			requestSchema: StartSearchRequestZ,
			responseSchema: StartSearchResponseZ,
			data: params,
			...overrides,
		})
		.then((r) => r.data)
}
